import { Link, createFileRoute } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"

import { IddZertifikat } from "@/components/idd/idd-zertifikat"
import { LoadState } from "@/components/load-state"
import { PrintButton } from "@/components/print-button"
import { Button } from "@/components/ui/button"
import { useDruckenSobald } from "@/lib/idd/drucken"
import { useIddNachweis } from "@/lib/idd-queries"

function NachweisPage() {
  const { id } = Route.useParams()
  const { drucken } = Route.useSearch()
  const { data, isError, refetch } = useIddNachweis(id)
  useDruckenSobald(Boolean(drucken && data))
  return (
    <div className="space-y-5">
      <div className="no-print flex flex-wrap items-center justify-between gap-2">
        <Button asChild variant="ghost" size="sm" className="-ml-2">
          <Link to="/idd/zertifikate">
            <ArrowLeft className="h-4 w-4" />
            Zertifikate
          </Link>
        </Button>
        {data && <PrintButton />}
      </div>
      {data ? (
        <IddZertifikat nachweis={data} />
      ) : (
        <LoadState failed={isError} onRetry={() => void refetch()}>
          Der Nachweis konnte nicht geladen werden.
        </LoadState>
      )}
    </div>
  )
}

export const Route = createFileRoute("/_app/idd/nachweis/$id")({
  validateSearch: (search: Record<string, unknown>): { drucken?: boolean } => ({
    drucken: search.drucken === true || search.drucken === "true" ? true : undefined,
  }),
  component: NachweisPage,
})
